import { mineralMattescreen, resettingPowder, protectint, unseenSunscreen, glowscreen, niacinamide, cetaphilMoisturizer, larocheToleriane } from "@/assets/products";

export interface LandscapeInstance {
  id: string;
  date: string;
  top4Hero: number; // count of keywords in top 4
  top4CompetitorAvg: number;
  page1Hero: number;
  page1CompetitorAvg: number;
  keywordCount: number;
}

export interface ConsolidatedLandscape {
  id: string;
  no: number;
  prioritySearchPhrase: string;
  instances: LandscapeInstance[]; // sorted by date, latest first
}

export interface HeroProduct {
  id: string;
  asin: string;
  title: string;
  imageUrl: string;
  landscapes: ConsolidatedLandscape[];
}

export const mockHeroProducts: HeroProduct[] = [
  {
    id: "1",
    asin: "B01LTI2ENW",
    title: "Supergoop! Mineral Mattescreen (SPF 40) - 45 mL - Mineral, Oil-Free Broad Spectrum Sunscreen - Smooths Skin's Appearance, Minimizes Pores & Controls Shine - Water & Sweat Resistant",
    imageUrl: mineralMattescreen,
    landscapes: [
      {
        id: "1-1",
        no: 1,
        prioritySearchPhrase: "chemical free sunscreen",
        instances: [
          { id: "1-1-17", date: "Feb 03, 2026", top4Hero: 19, top4CompetitorAvg: 23, page1Hero: 50, page1CompetitorAvg: 40, keywordCount: 135 },
          { id: "1-1-16", date: "Jan 27, 2026", top4Hero: 18, top4CompetitorAvg: 23, page1Hero: 49, page1CompetitorAvg: 39, keywordCount: 133 },
          { id: "1-1-15", date: "Jan 20, 2026", top4Hero: 17, top4CompetitorAvg: 22, page1Hero: 48, page1CompetitorAvg: 39, keywordCount: 131 },
          { id: "1-1-14", date: "Jan 13, 2026", top4Hero: 16, top4CompetitorAvg: 22, page1Hero: 47, page1CompetitorAvg: 39, keywordCount: 130 },
          { id: "1-1-13", date: "Jan 06, 2026", top4Hero: 16, top4CompetitorAvg: 22, page1Hero: 46, page1CompetitorAvg: 38, keywordCount: 129 },
          { id: "1-1-12", date: "Dec 30, 2025", top4Hero: 15, top4CompetitorAvg: 21, page1Hero: 46, page1CompetitorAvg: 38, keywordCount: 128 },
          { id: "1-1-11", date: "Dec 23, 2025", top4Hero: 15, top4CompetitorAvg: 21, page1Hero: 45, page1CompetitorAvg: 38, keywordCount: 127 },
          { id: "1-1-10", date: "Dec 16, 2025", top4Hero: 14, top4CompetitorAvg: 21, page1Hero: 44, page1CompetitorAvg: 37, keywordCount: 125 },
          { id: "1-1-9", date: "Dec 09, 2025", top4Hero: 14, top4CompetitorAvg: 21, page1Hero: 44, page1CompetitorAvg: 37, keywordCount: 124 },
          { id: "1-1-8", date: "Dec 02, 2025", top4Hero: 13, top4CompetitorAvg: 20, page1Hero: 43, page1CompetitorAvg: 37, keywordCount: 122 },
          { id: "1-1-7", date: "Nov 25, 2025", top4Hero: 13, top4CompetitorAvg: 20, page1Hero: 43, page1CompetitorAvg: 36, keywordCount: 121 },
          { id: "1-1-6", date: "Nov 18, 2025", top4Hero: 12, top4CompetitorAvg: 20, page1Hero: 42, page1CompetitorAvg: 36, keywordCount: 120 },
          { id: "1-1-5", date: "Nov 11, 2025", top4Hero: 12, top4CompetitorAvg: 20, page1Hero: 42, page1CompetitorAvg: 35, keywordCount: 119 },
          { id: "1-1-4", date: "Nov 04, 2025", top4Hero: 11, top4CompetitorAvg: 19, page1Hero: 41, page1CompetitorAvg: 35, keywordCount: 117 },
          { id: "1-1-3", date: "Oct 28, 2025", top4Hero: 10, top4CompetitorAvg: 19, page1Hero: 40, page1CompetitorAvg: 35, keywordCount: 115 },
          { id: "1-1-2", date: "Oct 14, 2025", top4Hero: 9, top4CompetitorAvg: 18, page1Hero: 39, page1CompetitorAvg: 34, keywordCount: 110 },
          { id: "1-1-1", date: "Oct 08, 2025", top4Hero: 8, top4CompetitorAvg: 18, page1Hero: 38, page1CompetitorAvg: 32, keywordCount: 105 },
        ]
      },
      {
        id: "1-2",
        no: 2,
        prioritySearchPhrase: "matte sunscreen",
        instances: [
          { id: "1-2-2", date: "Oct 15, 2025", top4Hero: 25, top4CompetitorAvg: 18, page1Hero: 58, page1CompetitorAvg: 42, keywordCount: 89 },
          { id: "1-2-1", date: "Oct 10, 2025", top4Hero: 22, top4CompetitorAvg: 16, page1Hero: 52, page1CompetitorAvg: 40, keywordCount: 82 },
        ]
      },
      {
        id: "1-3",
        no: 3,
        prioritySearchPhrase: "mineral sunscreen face",
        instances: [
          { id: "1-3-2", date: "Oct 16, 2025", top4Hero: 18, top4CompetitorAvg: 24, page1Hero: 48, page1CompetitorAvg: 45, keywordCount: 156 },
          { id: "1-3-1", date: "Oct 13, 2025", top4Hero: 16, top4CompetitorAvg: 22, page1Hero: 44, page1CompetitorAvg: 42, keywordCount: 148 },
        ]
      },
      {
        id: "1-4",
        no: 4,
        prioritySearchPhrase: "mattifying lotion",
        instances: [
          { id: "1-4-1", date: "Nov 13, 2025", top4Hero: 5, top4CompetitorAvg: 12, page1Hero: 22, page1CompetitorAvg: 28, keywordCount: 45 },
        ]
      },
      {
        id: "1-5",
        no: 5,
        prioritySearchPhrase: "sunscreen for face",
        instances: [
          { id: "1-5-1", date: "Jan 30, 2026", top4Hero: 32, top4CompetitorAvg: 28, page1Hero: 65, page1CompetitorAvg: 55, keywordCount: 234 },
        ]
      },
      {
        id: "1-6",
        no: 6,
        prioritySearchPhrase: "oil free sunscreen",
        instances: [
          { id: "1-6-1", date: "Feb 01, 2026", top4Hero: 21, top4CompetitorAvg: 19, page1Hero: 52, page1CompetitorAvg: 44, keywordCount: 112 },
        ]
      },
      {
        id: "1-7",
        no: 7,
        prioritySearchPhrase: "reef safe sunscreen face",
        instances: [
          { id: "1-7-1", date: "Jan 28, 2026", top4Hero: 14, top4CompetitorAvg: 20, page1Hero: 38, page1CompetitorAvg: 42, keywordCount: 87 },
        ]
      },
      {
        id: "1-8",
        no: 8,
        prioritySearchPhrase: "spf moisturizer for oily skin",
        instances: [
          { id: "1-8-1", date: "Jan 25, 2026", top4Hero: 10, top4CompetitorAvg: 15, page1Hero: 30, page1CompetitorAvg: 36, keywordCount: 64 },
        ]
      },
      {
        id: "1-9",
        no: 9,
        prioritySearchPhrase: "lightweight sunscreen",
        instances: [
          { id: "1-9-1", date: "Feb 05, 2026", top4Hero: 27, top4CompetitorAvg: 22, page1Hero: 59, page1CompetitorAvg: 48, keywordCount: 178 },
        ]
      },
      {
        id: "1-10",
        no: 10,
        prioritySearchPhrase: "non greasy sunscreen",
        instances: [
          { id: "1-10-1", date: "Feb 03, 2026", top4Hero: 23, top4CompetitorAvg: 20, page1Hero: 54, page1CompetitorAvg: 46, keywordCount: 145 },
        ]
      },
    ]
  },
  {
    id: "2",
    asin: "B0854MSAL1",
    title: "Supergoop! (Re) setting Mineral Powder, Translucent - 0.15 oz - Makeup Setting Powder + Broad Spectrum SPF 35 PA+++ Sunscreen - With Ceramides, Olive Glycerides & Coated Silica Spheres",
    imageUrl: resettingPowder,
    landscapes: [
      {
        id: "2-1",
        no: 1,
        prioritySearchPhrase: "powder sunscreen for face",
        instances: [
          { id: "2-1-2", date: "Oct 13, 2025", top4Hero: 28, top4CompetitorAvg: 20, page1Hero: 55, page1CompetitorAvg: 40, keywordCount: 78 },
          { id: "2-1-1", date: "Oct 08, 2025", top4Hero: 24, top4CompetitorAvg: 18, page1Hero: 50, page1CompetitorAvg: 38, keywordCount: 72 },
        ]
      },
      {
        id: "2-2",
        no: 2,
        prioritySearchPhrase: "sunscreen powder for face",
        instances: [
          { id: "2-2-2", date: "Oct 14, 2025", top4Hero: 22, top4CompetitorAvg: 16, page1Hero: 48, page1CompetitorAvg: 35, keywordCount: 65 },
          { id: "2-2-1", date: "Oct 08, 2025", top4Hero: 20, top4CompetitorAvg: 14, page1Hero: 45, page1CompetitorAvg: 32, keywordCount: 60 },
        ]
      },
      {
        id: "2-3",
        no: 3,
        prioritySearchPhrase: "mineral powder sunscreen",
        instances: [
          { id: "2-3-2", date: "Oct 14, 2025", top4Hero: 18, top4CompetitorAvg: 22, page1Hero: 42, page1CompetitorAvg: 45, keywordCount: 52 },
          { id: "2-3-1", date: "Oct 08, 2025", top4Hero: 15, top4CompetitorAvg: 20, page1Hero: 38, page1CompetitorAvg: 42, keywordCount: 48 },
        ]
      },
    ]
  },
  {
    id: "3",
    asin: "B0ENVVMF71",
    title: "Supergoop! Protec(tint) Daily Skin Tint SPF 50 - 22W - Light, Buildable Coverage for Immediately Smooth, Even-Looking Skin - Natural Finish",
    imageUrl: protectint,
    landscapes: [
      {
        id: "3-1",
        no: 1,
        prioritySearchPhrase: "skin tint sunscreen",
        instances: [
          { id: "3-1-2", date: "Oct 14, 2025", top4Hero: 12, top4CompetitorAvg: 18, page1Hero: 35, page1CompetitorAvg: 40, keywordCount: 42 },
          { id: "3-1-1", date: "Oct 08, 2025", top4Hero: 10, top4CompetitorAvg: 16, page1Hero: 32, page1CompetitorAvg: 38, keywordCount: 38 },
        ]
      },
      {
        id: "3-2",
        no: 2,
        prioritySearchPhrase: "skin tint spf",
        instances: [
          { id: "3-2-2", date: "Oct 14, 2025", top4Hero: 8, top4CompetitorAvg: 14, page1Hero: 28, page1CompetitorAvg: 32, keywordCount: 35 },
          { id: "3-2-1", date: "Oct 10, 2025", top4Hero: 6, top4CompetitorAvg: 12, page1Hero: 25, page1CompetitorAvg: 30, keywordCount: 32 },
        ]
      },
      {
        id: "3-3",
        no: 3,
        prioritySearchPhrase: "foundation with sunscreen",
        instances: [
          { id: "3-3-2", date: "Oct 14, 2025", top4Hero: 4, top4CompetitorAvg: 10, page1Hero: 18, page1CompetitorAvg: 25, keywordCount: 28 },
          { id: "3-3-1", date: "Oct 10, 2025", top4Hero: 3, top4CompetitorAvg: 8, page1Hero: 15, page1CompetitorAvg: 22, keywordCount: 25 },
        ]
      },
      {
        id: "3-4",
        no: 4,
        prioritySearchPhrase: "spf tinted",
        instances: [
          { id: "3-4-1", date: "Oct 13, 2025", top4Hero: 5, top4CompetitorAvg: 12, page1Hero: 20, page1CompetitorAvg: 28, keywordCount: 22 },
        ]
      },
    ]
  },
  {
    id: "4",
    asin: "B0DPM3B043",
    title: "Supergoop! Unseen Sunscreen SPF 50 Invisible Sun Protection for Face - Broad Spectrum Face Sunscreen + Makeup-Gripping Primer - Weightless, Scentless, Oil Free - For All Skin Types - 1.7 fl oz",
    imageUrl: unseenSunscreen,
    landscapes: [
      {
        id: "4-1",
        no: 1,
        prioritySearchPhrase: "face sunscreen for women",
        instances: [
          { id: "4-1-2", date: "Oct 14, 2025", top4Hero: 35, top4CompetitorAvg: 28, page1Hero: 68, page1CompetitorAvg: 52, keywordCount: 189 },
          { id: "4-1-1", date: "Oct 08, 2025", top4Hero: 30, top4CompetitorAvg: 25, page1Hero: 62, page1CompetitorAvg: 48, keywordCount: 175 },
        ]
      },
      {
        id: "4-2",
        no: 2,
        prioritySearchPhrase: "sunscreen for face",
        instances: [
          { id: "4-2-2", date: "Oct 14, 2025", top4Hero: 40, top4CompetitorAvg: 32, page1Hero: 72, page1CompetitorAvg: 58, keywordCount: 312 },
          { id: "4-2-1", date: "Oct 08, 2025", top4Hero: 36, top4CompetitorAvg: 30, page1Hero: 68, page1CompetitorAvg: 55, keywordCount: 298 },
        ]
      },
      {
        id: "4-3",
        no: 3,
        prioritySearchPhrase: "travel sunscreen",
        instances: [
          { id: "4-3-2", date: "Oct 13, 2025", top4Hero: 22, top4CompetitorAvg: 18, page1Hero: 48, page1CompetitorAvg: 38, keywordCount: 95 },
          { id: "4-3-1", date: "Oct 08, 2025", top4Hero: 18, top4CompetitorAvg: 15, page1Hero: 42, page1CompetitorAvg: 35, keywordCount: 88 },
        ]
      },
    ]
  },
  {
    id: "5",
    asin: "B08XY267890",
    title: "Supergoop! Glowscreen SPF 40 PA+++ - 1.7 fl oz - Glowy Primer + Broad Spectrum Sunscreen - Adds Instant Glow - Helps Filter Blue Light - For All Skin Types",
    imageUrl: glowscreen,
    landscapes: [
      {
        id: "5-1",
        no: 1,
        prioritySearchPhrase: "glowy sunscreen primer",
        instances: [
          { id: "5-1-2", date: "Feb 01, 2026", top4Hero: 26, top4CompetitorAvg: 20, page1Hero: 58, page1CompetitorAvg: 44, keywordCount: 142 },
          { id: "5-1-1", date: "Jan 25, 2026", top4Hero: 23, top4CompetitorAvg: 19, page1Hero: 54, page1CompetitorAvg: 42, keywordCount: 135 },
        ]
      },
      {
        id: "5-2",
        no: 2,
        prioritySearchPhrase: "spf primer for face",
        instances: [
          { id: "5-2-1", date: "Jan 28, 2026", top4Hero: 18, top4CompetitorAvg: 22, page1Hero: 45, page1CompetitorAvg: 48, keywordCount: 98 },
        ]
      },
      {
        id: "5-3",
        no: 3,
        prioritySearchPhrase: "blue light sunscreen",
        instances: [
          { id: "5-3-1", date: "Feb 03, 2026", top4Hero: 15, top4CompetitorAvg: 12, page1Hero: 38, page1CompetitorAvg: 30, keywordCount: 67 },
        ]
      },
    ]
  },
  {
    id: "6",
    asin: "B09KL345678",
    title: "Supergoop! Daily Dose Hydra-Ceramide Boost SPF 40 - 1 fl oz - Oil-Free Moisturizer + Sunscreen - Strengthens Skin Barrier - For All Skin Types",
    imageUrl: niacinamide,
    landscapes: [
      {
        id: "6-1",
        no: 1,
        prioritySearchPhrase: "spf moisturizer daily",
        instances: [
          { id: "6-1-2", date: "Feb 05, 2026", top4Hero: 34, top4CompetitorAvg: 26, page1Hero: 70, page1CompetitorAvg: 55, keywordCount: 210 },
          { id: "6-1-1", date: "Jan 29, 2026", top4Hero: 31, top4CompetitorAvg: 25, page1Hero: 66, page1CompetitorAvg: 52, keywordCount: 198 },
        ]
      },
      {
        id: "6-2",
        no: 2,
        prioritySearchPhrase: "ceramide sunscreen face",
        instances: [
          { id: "6-2-1", date: "Jan 30, 2026", top4Hero: 20, top4CompetitorAvg: 17, page1Hero: 48, page1CompetitorAvg: 40, keywordCount: 115 },
        ]
      },
    ]
  },
  {
    id: "7",
    asin: "B07GDC4VP3",
    title: "Supergoop! Smooth & Poreless 100% Mineral Matte Screen SPF 40 - 1.5 fl oz - Lightweight Mineral Sunscreen - Smooths Skin & Minimizes Pores - For Oily & Combination Skin",
    imageUrl: cetaphilMoisturizer,
    landscapes: [
      {
        id: "7-1",
        no: 1,
        prioritySearchPhrase: "poreless mineral sunscreen",
        instances: [
          { id: "7-1-2", date: "Feb 02, 2026", top4Hero: 28, top4CompetitorAvg: 24, page1Hero: 60, page1CompetitorAvg: 50, keywordCount: 176 },
          { id: "7-1-1", date: "Jan 26, 2026", top4Hero: 25, top4CompetitorAvg: 23, page1Hero: 56, page1CompetitorAvg: 48, keywordCount: 168 },
        ]
      },
      {
        id: "7-2",
        no: 2,
        prioritySearchPhrase: "matte sunscreen oily skin",
        instances: [
          { id: "7-2-1", date: "Jan 31, 2026", top4Hero: 22, top4CompetitorAvg: 20, page1Hero: 50, page1CompetitorAvg: 44, keywordCount: 130 },
        ]
      },
      {
        id: "7-3",
        no: 3,
        prioritySearchPhrase: "pore minimizing spf",
        instances: [
          { id: "7-3-1", date: "Feb 04, 2026", top4Hero: 16, top4CompetitorAvg: 18, page1Hero: 42, page1CompetitorAvg: 40, keywordCount: 88 },
        ]
      },
    ]
  },
  {
    id: "8",
    asin: "B01N7T7JKG",
    title: "Supergoop! Play Everyday Lotion SPF 50 - 5.5 fl oz - Broad Spectrum Body & Face Sunscreen - Water & Sweat Resistant - Clean Ingredients - Great for Active Days",
    imageUrl: larocheToleriane,
    landscapes: [
      {
        id: "8-1",
        no: 1,
        prioritySearchPhrase: "body sunscreen spf 50",
        instances: [
          { id: "8-1-2", date: "Feb 06, 2026", top4Hero: 30, top4CompetitorAvg: 22, page1Hero: 62, page1CompetitorAvg: 48, keywordCount: 185 },
          { id: "8-1-1", date: "Jan 30, 2026", top4Hero: 27, top4CompetitorAvg: 21, page1Hero: 58, page1CompetitorAvg: 46, keywordCount: 175 },
        ]
      },
      {
        id: "8-2",
        no: 2,
        prioritySearchPhrase: "water resistant sunscreen",
        instances: [
          { id: "8-2-1", date: "Feb 01, 2026", top4Hero: 12, top4CompetitorAvg: 16, page1Hero: 35, page1CompetitorAvg: 38, keywordCount: 72 },
        ]
      },
    ]
  },
];
